import { render, staticRenderFns } from "./brandDetail.vue?vue&type=template&id=28e047d2"
import script from "./brandDetail.vue?vue&type=script&lang=js"
export * from "./brandDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports